
import CameraStatusTile from 'camera-module/camera/ui/camera-status-page/CameraStatusTile'
import BatteryType from 'assets/icons/status/BatteryType'

const SpypointVBatteryTile = ({ value }) => (
  <CameraStatusTile label="app:camera.battery1" icon={<BatteryType />} value={`${value.percentage}%`} useSVGIcon />
)

export default SpypointVBatteryTile
